<script lang="ts">
    // Mesma ideia do inlineselect: as opções ficam lado a lado, com a escolhida destacada. A diferença
    // é o que desenha cada opção — aqui é o Zbutton, e não uma div própria. É o btn-group do bootstrap
    // reproduzido com a peça que o design system já tem, então hover, foco, disabled e as cores saem
    // de graça e acompanham qualquer mudança feita no botão.
    //
    // O destaque da opção escolhida vem da prop `active` do Zbutton, que preenche o botão com a cor
    // dele. Por isso `color` aqui vale por opção: um seletor de status pode ter a opção de cancelar em
    // vermelho e ainda assim marcá-la como escolhida.
    import { createEventDispatcher } from 'svelte'
    import Zbutton from '../zbutton.svelte'

    export let value: any = null
    export let options: { value: any; label: string; disabled?: boolean; color?: 'green' | 'red' | 'yellow' | 'secondary' | 'primary' }[] = []
    export let disabled = false
    export let multi = false
    export let labeled = false
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    $: safeValue = multi ? (Array.isArray(value) ? value : []) : value

    function isSelected(v, sel) {
        if (multi) return sel.includes(v)
        return sel === v
    }

    function selectOption(opt) {
        if (disabled || opt.disabled) return
        if (multi) {
            const arr = Array.isArray(value) ? [...value] : []
            const index = arr.indexOf(opt.value)
            if (index >= 0) {
                arr.splice(index, 1)
            } else {
                arr.push(opt.value)
            }
            value = arr
        } else {
            value = opt.value
        }
        dispatch('change')
    }
</script>

<div class="zinput-inlineselect-2 zinput_input zinput_input_labeled-{labeled}" bind:this={htmlInput}>
    {#each options as opt (opt.value)}
        <Zbutton
            label={opt.label}
            color={opt.color || 'secondary'}
            active={isSelected(opt.value, safeValue)}
            disabled={disabled || opt.disabled}
            grow={true}
            on:click={() => selectOption(opt)}
        />
    {/each}
</div>

<style>
    .zinput-inlineselect-2 {
        display: flex;
        align-items: stretch;
        width: 100%;
    }

    /* com label existe campo em volta, e os botões ocupam o espaço que sobra abaixo dela:
       a altura fixa de 44px do Zbutton sai de cena e quem manda é o container. */
    .zinput-inlineselect-2.zinput_input_labeled-true {
        padding-left: 4px;
        padding-right: 4px;
        padding-bottom: 4px;
    }

    .zinput-inlineselect-2.zinput_input_labeled-true :global(.zbutton) {
        height: auto;
        min-height: 0px;
    }

    /* sem label não há campo em volta e o botão fica com a altura natural dele — nada a fazer
       além de zerar o padding, que aqui viraria um deslocamento visível. */
    .zinput-inlineselect-2.zinput_input_labeled-false {
        padding: 0px;
    }

    /* btn-group: encostados, com a borda compartilhada em vez de duplicada, e só as pontas
       do grupo arredondadas */
    .zinput-inlineselect-2 :global(.zbutton) {
        border-radius: 0px;
        font-size: 14px;
    }

    .zinput-inlineselect-2 :global(.zbutton + .zbutton) {
        margin-left: -1px;
    }

    .zinput-inlineselect-2 :global(.zbutton:first-child) {
        border-top-left-radius: var(--z-field-radius);
        border-bottom-left-radius: var(--z-field-radius);
    }

    .zinput-inlineselect-2 :global(.zbutton:last-child) {
        border-top-right-radius: var(--z-field-radius);
        border-bottom-right-radius: var(--z-field-radius);
    }

    /* o botão escolhido tem borda sólida: sem isto, a borda do vizinho passaria por cima dela */
    .zinput-inlineselect-2 :global(.zbutton.is-active-true) {
        z-index: 1;
    }
</style>
